import React, { forwardRef, useImperativeHandle } from "react";
import Backdrop from "@mui/material/Backdrop";
import { Box, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomModal = forwardRef(function Modal(props, ref) {
  const {
    children,
    childrenContSx,
    ariaLabel = "modal",
    cleanUp = () => {},
    backdropSx = {},
  } = props;
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    cleanUp();
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  useImperativeHandle(ref, () => {
    return {
      handleToggle,
    };
  });
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        m: "0px !important",
        ...backdropSx,
      }}
      open={open}
      aria-label={ariaLabel}
    >
      {/* Frame: sized to the modal, never scrolls. The close button lives here
          so it stays pinned to the top-right corner while the content scrolls. */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          maxWidth: "90%",
          maxHeight: "95%",
        }}
      >
        <IconButton
          onClick={handleClose}
          aria-label="close modal"
          sx={{
            position: "absolute",
            top: 8,
            right: 16,
            zIndex: 2,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Only this part scrolls */}
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
          }}
        >
          <Paper
            sx={{
              p: 2,
              width: "auto",
              minHeight: "40%",
              margin: "auto",
              minWidth: {
                xs: "90%",
                sm: "30%",
              },
              position: "relative",
              ...childrenContSx,
            }}
          >
            {open ? children : null}
          </Paper>
        </Box>
      </Box>
    </Backdrop>
  );
});

export default CustomModal;